interface SequenceWithTemplateName {
  templateName?: string;
}

interface TemplateItem {
  name: string;
}

interface TemplatesCollection {
  text?: TemplateItem[];
  media?: TemplateItem[];
  communication?: TemplateItem[];
  interactive?: TemplateItem[];
  quiz?: TemplateItem[];
}

export function isTemplateSupportedForEditing(
  sequence: SequenceWithTemplateName | null,
  templates: TemplatesCollection | null | undefined,
  templatesLoading: boolean,
  templatesError: string | null
): boolean {
  if (templatesLoading || templatesError) return true;
  if (!sequence?.templateName || !templates) return true;

  const allTemplates = [
    ...(templates.text || []),
    ...(templates.media || []),
    ...(templates.communication || []),
    ...(templates.interactive || []),
    ...(templates.quiz || [])
  ];

  return allTemplates.some(
    (template: TemplateItem) => template.name === sequence.templateName
  );
}
